import { render, staticRenderFns } from "./ContractorView.vue?vue&type=template&id=4485f99e"
import script from "./ContractorView.vue?vue&type=script&lang=js"
export * from "./ContractorView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports